import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/rt_rule/conditions': fetchList,
  // 新增
  'POST/rt_rule': rt_ruleAddApi,
  // RT规则_删除(取消)
  'DELETE/rt_rule': rt_ruleDelApi,

} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchHandle = (params: any) => {
  fetchData({
    query: params
  })
}
const searchConfig = ref([
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { clearable: true }
  },
  /* {
    label: "译员邮箱",
    value: '',
    upKey: 'resourceEmail',
    props: { clearable: true }
  }, */
])
// 添加
const addConfig = ref([
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { clearable: true },
    rule: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value && !addConfig.value[1].value) {
            callback(new Error('ID和邮箱不能都为空'))
          }
          callback()
        }, trigger: 'change'
      },
    ],
  },
  {
    label: "译员邮箱",
    value: '',
    upKey: 'resourceEmail',
    props: { clearable: true },
    rule: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value && !addConfig.value[0].value) {
            callback(new Error('ID和邮箱不能都为空'))
          }
          callback()
        }, trigger: 'change'
      },
    ],
  },
])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async (params: any) => {
    await rt_ruleAddApi(params)
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '是否取消?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return rt_ruleDelApi({id: row.id}, { contentType: 'formData'})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('取消成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "成本规则搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle())),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "译员id",
          prop: "resourceId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否内部译员",
          prop: "isCcjkUser",
          "show-overflow-tooltip": "",
          formatter: (row) => row.isCcjkUser === true ? '是' : '否'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "是否计算",
          prop: "isNoCalculated",
          formatter: (row) => row.isNoCalculated === true ? '不计算' : '计算'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "是否取消",
          prop: "cancelled",
          formatter: (row) => row.cancelled === true ? '已取消' : '未取消'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createdTime",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建人",
          prop: "createdBy",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  disabled: row.cancelled,
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100,],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: addConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})